import React, { useEffect, useReducer, useState } from 'react';

import { Content } from 'antd/es/layout/layout';
import { Avatar, Breadcrumb, Button, Card, Col, Empty, Form, Input, message, Modal, Popover, Row, Select, Space, Spin, Table, Tag, Typography } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, InfoOutlined, BookOutlined, HomeOutlined } from '@ant-design/icons';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useFormik } from 'formik';
import axios from 'axios';
import surveySeriesReducer from './reducer';
import { SURVEY_SERIES_LIST, SURVEY_SERIES_LIST_ERROR, SURVEY_SERIES_LIST_SUCCESS, SURVEY_SERIES_UPDATE_DATA } from './constants';
import { useLocation, useNavigate } from 'react-router-dom';

const { Title } = Typography;

export default function SurveySeries() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const initalState = {surveySeries : [], loading: false, error: false, updateData : {}};
	const { state } = useLocation();
	const navigate = useNavigate();
	const [data, dispatch] = useReducer(surveySeriesReducer, initalState);
	const [showAddModal, setShowAddModal] = useState(state && state.data && state.data.showAddModal ? state.data.showAddModal : false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [updateId, setUpdateId] = useState();
	const [deleteId, setDeleteId] = useState();

	const statuslist = [
		{value: 'New', label: langdata && langdata.New ? langdata.New : 'New'},
		{value: 'Completed', label: langdata && langdata.Completed ? langdata.Completed : 'Completed'},
		{value: 'Failed', label: langdata && langdata.Failed ? langdata.Failed : 'Failed'}
	];
		
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		loadSurveySeries();
	},[]);

	const loadSurveySeries = () => {
		dispatch({ type : SURVEY_SERIES_LIST });
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/surveyseries?$sort[id]=1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`	
			}
		};
		
		axios.request(config)
			.then((response) => {
				if(response.status == 200){
					dispatch({ type : SURVEY_SERIES_LIST_SUCCESS, payload : response.data.data });
				} else {
					dispatch({ type : SURVEY_SERIES_LIST_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : SURVEY_SERIES_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const column = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: `${langdata && langdata.Status ? langdata.Status:'Status'}`,
			dataIndex: 'status',
			key: 'status',
			render: (_, surveystatus) => (
				<>
					{surveystatus &&
						<Tag color={surveystatus.status=='New' ? 'blue' : surveystatus.status=='Inprogress' ? 'gold' : 
							surveystatus.status=='Insufficient Data' ? 'gold' : surveystatus.status=='Failed' ? 'red' : surveystatus.status=='Completed' ? 'green' : 
								surveystatus.status=='Inversion Completed' ? '#1e6ed6a8' : ''}>
							{surveystatus.status}
						</Tag>}
				</>
			),
		},
	];

	permission==='superadmin' || permission === 'admin' ? 
		column.push({
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				<>
					<a title={langdata && langdata.Editsurveyseries ? langdata.Editsurveyseries : 'Edit survey series'} onClick={() => {handleEditModal(record);}} ><EditOutlined/></a>
					{permission==='superadmin' || permission === 'admin' ? 
						<Button title={langdata && langdata.DeleteVSPSurvey ? langdata.DeleteVSPSurvey:'Delete VSP Survey'} type='link' disabled = {record.status == 'New' ? false : true}  onClick={() => {handleDeleteModal(record);}}><DeleteOutlined/></Button>
						: null }
				</>
			)
		}) : null;

	const handleAddModal = () => {
		setShowAddModal(true);
	};

	const closeModal = () => {
		setShowAddModal(false);
		setShowEditModal(false);
		setShowDeleteModal(false);
	};

	const handleEditModal = (value) => {
		setShowEditModal(true);
		setUpdateId(value.id);
		dispatch({ type : SURVEY_SERIES_UPDATE_DATA, payload : value});
	};

	const handleDeleteModal = (value) => {
		setShowDeleteModal(true);
		setDeleteId(value.id);
	};

	const addFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: null,
		},
		onSubmit: (values) => {
			const {name} = values;
			if( name == null ){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}
			let data = JSON.stringify({
				'name': name,
				'status': 'New',
				'pipelineId': parseInt(pipelineId)
			});

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/surveyseries`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`				},
				data : data
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201) {
						Modal.success({ title: langdata && langdata.Surveyseriesaddedsuccessfully ? langdata.Surveyseriesaddedsuccessfully : 'Survey series added successfully.' });	
						loadSurveySeries();
						addFormik.resetForm();
					} else {
						Modal.warning({ title: langdata && langdata.Surveyseriesnotadded ? langdata.Surveyseriesnotadded : 'Survey series not added.' });					
					}
				})
				.catch((error) => {
					console.log(error);
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Surveyseriesnotadded ? langdata.Surveyseriesnotadded : 'Survey series not added.' });					
					}
				});
			setShowAddModal(false);				
		}
	});

	const editFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: data.updateData.name,
			status: data.updateData.status,
		},
		onSubmit: (values) => {
			const {name, status} = values;
			if( name == null || name == ''){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}
			let data = JSON.stringify({
				'name': name,
				'status': status
			});

			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/surveyseries/${updateId}`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`				
				},
				data : data
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201) {
						Modal.success({ title: langdata && langdata.Surveyseriesupdatedsuccessfully ? langdata.Surveyseriesupdatedsuccessfully : 'Survey series updated successfully.' });					
						loadSurveySeries();
					} else {
						Modal.warning({ title: langdata && langdata.Surveyseriesnotupdated ? langdata.Surveyseriesnotupdated : 'Survey series not updated.' });					
					}
				})
				.catch((error) => {
					console.log(error);
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Surveyseriesnotupdated ? langdata.Surveyseriesnotupdated : 'Survey series not updated.' });					
					}
				});
			setShowEditModal(false);
		}
	});

	const handleDelete = () => {

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/surveyseries/${deleteId}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				},
			data : data
		};

		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){
					loadSurveySeries();
					Modal.success({ title: langdata && langdata.Surveyseriesdeletedsuccessfully ? langdata.Surveyseriesdeletedsuccessfully : 'Survey series deleted successfully.' });					
				} else {
					Modal.warning({ title: langdata && langdata.Surveyseriesnotdeleted ? langdata.Surveyseriesnotdeleted : 'Survey series not deleted.' });					
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					Modal.warning({ title: langdata && langdata.Surveyseriesnotdeleted ? langdata.Surveyseriesnotdeleted : 'Survey series not deleted.' });
				}
			});
		setShowDeleteModal(false);
	};

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p style={{textAlign:'justify'}}> {langdata && langdata.SurveyseriesDescription1 ? langdata.SurveyseriesDescription1 : 'This module is designed to manage various surveys conducted across well fields. It enables users to track the progress of each survey, maintain historical records, and organize survey data efficiently. Through this module, users can initiate new surveys, monitor their status (e.g., New, Completed, Failed), and associate them with specific wells or fields. This ensures systematic data collection and aids in analysis and reporting for operational and research purposes.'} </p>
		</Card>
	);
	
	return (
		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center',
			}}
			>
				<Col span={8}>
					<Row>
						<Space>
							<BookOutlined style={{fontSize:'30px'}}/>
						</Space>
						<Space>&nbsp;&nbsp;</Space>
						<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.SurveySeries ? langdata.SurveySeries : 'Survey Series'}</Title>
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Col>
							{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>User Type:</Text> */}
							{permission==='superadmin' || permission === 'admin' ?
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={handleAddModal}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
								: null }
							<Space>&nbsp;&nbsp;&nbsp;</Space>
								
							<Popover title={langdata && langdata.SurveySeries ? langdata.SurveySeries : 'Survey Series'}  content={infoContent} trigger="click">
								<Avatar size="small"><InfoOutlined /></Avatar>
							</Popover>
						</Col>
					</Row>
				</Col>
			</Row>

			{
				state && state.path ?

					<Row style={{
						margin: '10px',
						// marginTop : '5px',
						// paddingLeft: '10px',
						// paddingRight: '10px',
						// background: '#FFFFFF',
						alignItems:'center',
					}}  >
						<Col>
							<Breadcrumb
								items={[
									{
										href: '/dashboard',
										title: <HomeOutlined />,
									},
									{
										title: ( state && state.path === 'well-visualization' ? <a onClick={()=>{navigate(-3);}}>{langdata && langdata.WellVisualization ? langdata.WellVisualization:'Well Visualization'}</a> :  <a onClick={()=>{navigate(-3);}}>{langdata && langdata.WellVisualization ? langdata.WellVisualization:'Well Visualization'}</a>)
									},
									{
										title: ( state && state.path === 'vsp-survey-details' ? <a onClick={()=>{navigate(-2);}}>{langdata && langdata.VSPSurvey ? langdata.VSPSurvey:'VSP Survey'}</a> :  <a onClick={()=>{navigate(-2);}}>{langdata && langdata.VSPSurvey ? langdata.VSPSurvey:'VSP Survey'}</a>)
									},
									{
										title: ( state && state.path === 'vsp-survey-details' ? <a onClick={()=>{navigate(-1);}}>{langdata && langdata.VSPSurveyDetails ? langdata.VSPSurveyDetails:'VSP Survey Details'}</a> :  <a onClick={()=>{navigate(-1);}}>{langdata && langdata.VSPSurveyDetails ? langdata.VSPSurveyDetails:'VSP Survey Details'}</a>)
									},
									{
										title: `${langdata && langdata.SurveySeries ? langdata.SurveySeries : 'Survey Series'}`,
									},
								]}
								// style={{ marginBottom : '10px'}}
							/>
						</Col>
					</Row>
					: null
			}


			<Row span={24} style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
				<Col span={24}>
					{ data && data.surveySeries.length > 0 ? (
						<Table
							scroll={{
								x: 900,
							}}
							columns = { column } 
							dataSource = { data.surveySeries } 
						/>
					)
						:
						(
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						)}
				</Col>
			</Row>
			
			<Modal
				title={langdata && langdata.AddSurveySeries ? langdata.AddSurveySeries : 'Add Survey Series'}
				centered
				open={showAddModal}
				onOk={{closeModal}}
				onCancel={closeModal}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary" onClick={addFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE'}</Button>
					</Space>
				]}
				width={500}
			>
				<Form layout="vertical" onSubmit={addFormik.handleSubmit}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.SurveyName ? langdata.SurveyName : 'Survey Name'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthesurveyname ? langdata.Pleaseenterthesurveyname : 'Please enter the survey name' }]} required>
								<Input 
									name="name" 
									onChange={addFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthesurveyname ? langdata.Pleaseenterthesurveyname : 'Please enter the survey name'} 
									value={addFormik.values.name} 
								/>
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Modal>


			<Modal
				title={langdata && langdata.EditSurveySeries ? langdata.EditSurveySeries : 'Edit Survey Series'}
				centered
				open={showEditModal}
				onOk={{closeModal}}
				onCancel={closeModal}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary" onClick={editFormik.handleSubmit}>{langdata && langdata.UPDATE ? langdata.UPDATE : 'UPDATE'}</Button>
					</Space>
				]}
				width={500}
			>
				<Form layout="vertical" onSubmit={editFormik.handleSubmit}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.SurveyName ? langdata.SurveyName : 'Survey Name'}
								rules={[{ required: true, message: langdata && langdata.Pleaseenterthesurveyname ? langdata.Pleaseenterthesurveyname : 'Please enter the survey name' }]} required>
								<Input 
									name="name" 
									onChange={editFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthesurveyname ? langdata.Pleaseenterthesurveyname : 'Please enter the survey name'} 
									value={editFormik.values.name} 
								/>
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item 
								label={langdata && langdata.Status ? langdata.Status  : 'Status'} 
								rules={[{ required: true, message: langdata && langdata.Pleaseselectloggingstatus ? langdata.Pleaseselectloggingstatus : 'Please select logging status' }]} required>
								<Select
									style={{ minWidth: '200px', margin:'5px'}}
									showSearch
									// filterOption={filterOption}
									placeholder={ langdata && langdata.Pleaseselectloggingstatus ? langdata.Pleaseselectloggingstatus : 'Please select logging status' }
									optionFilterProp="children"
									options={statuslist}
									onChange={(value) => editFormik.setFieldValue('status', value)}
									value={editFormik.values.status}
								/>
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Modal>

			<Modal title={langdata && langdata.Confirmdelete ? langdata.Confirmdelete : 'Confirm delete'} open={showDeleteModal} onOk={closeModal} onCancel={closeModal}
				footer={[
				// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeModal}>{langdata && langdata.CANCEL ? langdata.CANCEL : 'CANCEL'}</Button>
						<Button key="submit" type="primary" onClick={handleDelete}>{langdata && langdata.DELETE ? langdata.DELETE : 'DELETE'}</Button>
					</Space>
				]}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}>{ langdata && langdata.Areyousureyouwanttodeletethis ? langdata.Areyousureyouwanttodeletethis :'Are you sure you want to delete this ?'}</Col>
				</Row>
			</Modal>


			<Spin fullscreen spinning={data.loading} />
		</Content>
	);
}